import React, { useState } from 'react';
import clsx from 'clsx';

export default function Input({
    value,
    onChange,
    onClick,
    label,
    disabled,
    placeholder,
    type,
    rightIcon,
    leftIcon,
    name,
    error: _error,
    width,
}: {
    value: string | undefined | number | null;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
    label?: string;
    disabled?: boolean;
    placeholder?: string;
    type?: 'text' | 'email' | 'number' | 'password';
    rightIcon?: React.ReactNode;
    leftIcon?: React.ReactNode;
    name?: string;
    error?: string | undefined | boolean;
    width?: string;
}) {
    const [dirty, setDirty] = useState(false);

    const error = dirty && _error;

    return (
        <label htmlFor={name}>
            {label && <div className="text-sm font-medium pb-1.5 text-label">{label}</div>}
            <div className="relative">
                <input
                    name={name}
                    disabled={disabled}
                    value={value || ''}
                    type={type}
                    onClick={onClick}
                    onChange={(e) => {
                        if (onChange) onChange(e);
                        setDirty(true);
                    }}
                    onBlur={() => {
                        setDirty(true);
                    }}
                    placeholder={placeholder}
                    className={clsx(
                        'border rounded-lg text-sm transition-colors py-2 focus:outline-none',
                        width || 'w-full',
                        leftIcon ? 'pl-9' : 'pl-3',
                        rightIcon ? 'pr-9' : 'pr-3',
                        disabled
                            ? 'cursor-not-allowed bg-border-subtle text-foreground-muted border-border'
                            : 'bg-surface-muted text-foreground placeholder-foreground-muted border-border focus:bg-surface focus:border-border-strong'
                    )}
                />
                {leftIcon && (
                    <div className="absolute left-0 top-0 bottom-0 flex items-center pl-3 text-foreground-muted pointer-events-none">
                        {leftIcon}
                    </div>
                )}
                {rightIcon && (
                    <div className="absolute right-0 top-0 bottom-0 flex items-center pr-3 text-foreground-muted">
                        {rightIcon}
                    </div>
                )}
            </div>
            {error && <div className="mt-1 text-xs text-danger">{error}</div>}
        </label>
    );
}
